import React from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#001a0d] py-16 px-4" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="text-center mb-10" data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-77">
            🕊️ ¿Qué agrega el{' '}
            <span className="text-[#39FF14]" data-id="element-78">Kit Adaptaciones</span>?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-79">
            Vos ya tenés el material para el 80% del aula. El MegaPack +
            Adaptaciones resuelve el 20% que más tiempo te consume.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#39FF14]/30 rounded-2xl overflow-hidden mb-12" data-id="element-80">
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#000d08] border-b border-[#39FF14]/30" data-id="element-81">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-82">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#39FF14]/30" data-id="element-83">
              Sin Adaptaciones
            </div>
            <div className="p-4 font-bold text-[#39FF14] text-center border-l border-[#39FF14]/30" data-id="element-84">
              Con Adaptaciones
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-85">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-86">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-87">
                Situación:
              </span>
              Valentina tiene NEE y no puede hacer la actividad estándar
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-88">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-89">
                Sin Adaptaciones:
              </span>
              Improvisás algo "más fácil" en el momento
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#39FF14]/5" data-id="element-90">
              <span className="sm:hidden font-bold text-[#39FF14] block mb-1" data-id="element-91">
                Con Adaptaciones:
              </span>
              Imprimís la versión Basic del Contenido Espejo. 30 segundos.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-92">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-93">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-94">
                Situación:
              </span>
              Marcos necesita el examen diferente el día del trimestral
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-95">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-96">
                Sin Adaptaciones:
              </span>
              Armás otro examen el domingo a la noche
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#39FF14]/5" data-id="element-97">
              <span className="sm:hidden font-bold text-[#39FF14] block mb-1" data-id="element-98">
                Con Adaptaciones:
              </span>
              Abrís el banco de evaluaciones diferenciadas. Ya está listo.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-99">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-100">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-101">
                Situación:
              </span>
              La inspectora pide ver el registro de adecuaciones
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-102">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-103">
                Sin Adaptaciones:
              </span>
              Buscás algo que no encontrás
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#39FF14]/5" data-id="element-104">
              <span className="sm:hidden font-bold text-[#39FF14] block mb-1" data-id="element-105">
                Con Adaptaciones:
              </span>
              Mostrás la plantilla de seguimiento firmada. Profesional.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3" data-id="element-106">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-107">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-108">
                Situación:
              </span>
              Alumno con dislexia no puede leer el texto del tomo
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-109">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-110">
                Sin Adaptaciones:
              </span>
              Dictás o simplificás en el momento
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#39FF14]/5" data-id="element-111">
              <span className="sm:hidden font-bold text-[#39FF14] block mb-1" data-id="element-112">
                Con Adaptaciones:
              </span>
              Imprimís la ficha de Lectura Fácil. Ya está hecha.
            </div>
          </div>
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-113">
          ✅ El Kit incluye:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-114">
          <div className="bg-black border border-[#39FF14]/20 rounded-xl p-5" data-id="element-115">
            <h4 className="text-[#39FF14] font-bold text-lg mb-2" data-id="element-116">
              Sistema "Contenido Espejo" (3 Velocidades)
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-117">
              La MISMA lección del Pack en 3 versiones: BASIC / ESTÁNDAR / PLUS.
              Todos trabajan el mismo tema al mismo tiempo.
            </p>
          </div>
          <div className="bg-black border border-[#39FF14]/20 rounded-xl p-5" data-id="element-118">
            <h4 className="text-[#39FF14] font-bold text-lg mb-2" data-id="element-119">
              Português Simplificado — Lectura Fácil
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-120">
              6 textos auténticos adaptados. Mismas ideas, menor carga
              cognitiva. Para alumnos con dislexia, TDAH o bajo nivel lector.
            </p>
          </div>
          <div className="bg-black border border-[#39FF14]/20 rounded-xl p-5" data-id="element-121">
            <h4 className="text-[#39FF14] font-bold text-lg mb-2" data-id="element-122">
              Visual Learning — Fichas 100% Pictográficas
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-123">
              5 fichas de gramática y vocabulario basadas en imágenes. Mapa de
              emociones en português. SER vs ESTAR visual. Tiempos verbales en
              línea de tiempo.
            </p>
          </div>
          <div className="bg-black border border-[#39FF14]/20 rounded-xl p-5" data-id="element-124">
            <h4 className="text-[#39FF14] font-bold text-lg mb-2" data-id="element-125">
              Evaluaciones Diferenciadas Listas
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-126">
              3 versiones de evaluación por unidad (APOYO / CRUCERO / VUELO) +
              versión NEE específica. Criterios de calificación diferenciados.
            </p>
          </div>
          <div className="bg-black border border-[#39FF14]/20 rounded-xl p-5" data-id="element-127">
            <h4 className="text-[#39FF14] font-bold text-lg mb-2" data-id="element-128">
              Guía de Inclusión Práctica NEE
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-129">
              Adaptaciones específicas por perfil: Dislexia / TDAH /
              Discapacidad Intelectual Leve / TEA. Comunicado de adaptación para
              familias listo.
            </p>
          </div>
          <div className="bg-black border border-[#39FF14]/20 rounded-xl p-5" data-id="element-130">
            <h4 className="text-[#39FF14] font-bold text-lg mb-2" data-id="element-131">
              Fichas Slow-Track — El Camino Seguro
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-132">
              4 fichas de andamiaje completo para alumnos que necesitan más
              tiempo y más soporte.
            </p>
          </div>
          <div className="bg-black border border-[#39FF14]/20 rounded-xl p-5" data-id="element-133">
            <h4 className="text-[#39FF14] font-bold text-lg mb-2" data-id="element-134">
              Pictogramas de Aula en Português
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-135">
              Set A: Instrucciones de clase. Set B: Agenda visual del día. Set
              C: Semáforo de comprensión.
            </p>
          </div>
        </div>
      </div>
    </section>;
}